
import { Navigate } from 'react-router-dom';

export const PublicRoutes = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token'); // You can enhance this check based on your needs

  return !isAuthenticated ? children : <Navigate to="/" />;
};